module.exports = __webpack_public_path__ + "webfonts/398F09_0_0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/webfonts/398F09_0_0.svg
// module id = 54
// module chunks = 0